import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectAdminToken } from './sessionSlice';

export const processQuestions = createAsyncThunk(
  'theme/processQuestions',
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token = selectAdminToken(state);
      const currentTheme = state.theme.currentTheme;
      console.log("processQuestions → theme:", currentTheme);
      if (!currentTheme) {
        throw new Error('No currentTheme set');
      }

      const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/processQuestions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ currentTheme }),
      });

      const data = await resp.json().catch(() => ({}));
      console.log("processQuestions response:", data);

      if (!resp.ok) {
        return rejectWithValue(data.message || `processQuestions failed (${resp.status})`);
      }

      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
